import { IUserPreferenceData, UserPreferenceRecord } from "common/records/UserPreference";
import { fetcher } from "common/api/Fetcher";

export interface IUserPrefResponse {
  user_preference: IUserPreferenceData;
}

export const pref_url = "/api/v1/users/:user_id/user_preferences/:id";

export const updatePreference = (userId: number, userPref: UserPreferenceRecord): Promise<IUserPrefResponse> => {
  const actionUrl = pref_url.replace(":user_id", userId.toString()).replace(":id", userPref.id.toString());
  const postBody: any = { user_preference: cleanPrefProps(userPref) };

  return fetcher.patch(actionUrl, postBody);
};

const cleanPrefProps = (userPref: UserPreferenceRecord): any => {
  const data: any = userPref.toJS();

  if (data.sms_number) {
    if (data.sms_number.id <= 0) {
      delete data.sms_number.id;
    }

    data.sms_number_attributes = data.sms_number;
    delete data.sms_number;
  }

  return data;
};
